/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_ManageInputs */

const en_plan_manage = /** @type {(inputs: Plan_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Plan`)
};

const es_plan_manage = /** @type {(inputs: Plan_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar plan`)
};

/**
* | output |
* | --- |
* | "Manage Plan" |
*
* @param {Plan_ManageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_manage = /** @type {((inputs?: Plan_ManageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_ManageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_manage(inputs)
	return en_plan_manage(inputs)
});